import { Button } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import cat from "../../assets/images/cat.png";
import RaksLogo from "../../components/raksLogo";
import { ZaproszeniePageStyle } from "../../styles/ZaproszeniePageStyle";

const ZaproszenieErrorPage = () => (
  <ZaproszeniePageStyle>
    <header>
      <RaksLogo />
      <Link to={`/login`}>
        <Button variant="outlined" color="secondary">
          ZALOGUJ SIĘ
        </Button>
      </Link>
    </header>
    <div className="info">
      <img src={cat} alt="cat" />
      <h4>Twoje zaproszenie wygasło lub zostało usunięte.</h4>
    </div>
  </ZaproszeniePageStyle>
);

export default ZaproszenieErrorPage;
